import { useCallback } from 'react';

import { requestBuilder } from '../../../http/RequestBuilder';
import type { User } from '../../../user/types/User';

export interface UpdateMemberInfoBody {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    dateOfBirth: string;
}

interface UpdateMemberInfoURLParams {
    userId: string;
}

interface UpdateMemberInfoParam
    extends UpdateMemberInfoBody, UpdateMemberInfoURLParams {
    onSuccess: (user: User) => void;
    onError: (error: Error) => void;
}

const useMutateMemberInfo = requestBuilder.mutation<
    User,
    UpdateMemberInfoBody,
    UpdateMemberInfoURLParams
>({
    endpoint: ({ userId }) => `/api/user/${userId}/contactInfo`,
    method: 'PATCH',
});

export const useUpdateMemberInfo = () => {
    const { mutate, isPending } = useMutateMemberInfo();

    const updateMemberInfo = useCallback(
        ({
            userId,
            firstName,
            lastName,
            phoneNumber,
            dateOfBirth,
            onSuccess,
            onError,
        }: UpdateMemberInfoParam) => {
            mutate(
                {
                    urlParams: {
                        userId,
                    },
                    body: {
                        firstName,
                        lastName,
                        phoneNumber,
                        dateOfBirth,
                    },
                },
                {
                    onSuccess,
                    onError,
                },
            );
        },
        [mutate],
    );

    return {
        updateMemberInfo,
        isUpdatingMemberInfo: isPending,
    };
};
